import React from 'react'

export const ArrowTop = () => {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="https://www.w3.org/2000/svg">
      <path d="M8.25 5.25L4.75 1.75L1.25 5.25" stroke="#B0AFAF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
